<template>
    <rkm-overlay>
        <rkm-layout-body title="Assistência social">
            <rkm-layout-content v-if="loaded">
                <List :data="{ initials, form, model, additionals }" />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
import List from '@/components/pronto-atendimento/assistencia-social/List'

import { mapActions } from 'vuex'
import { repository, error, object, data } from '@/mixins'

export default {
    components: { List },
    created() {

        this.repositories = {
            assistenciaSocial: this.getConectaSusRepository('prontoAtendimento.assistenciaSocial')
        }

        this.load()
    },
    data: () => ({
        loaded: false,
        initials: {
            model: {}
        },
        form: {},
        model: {},
        additionals: {},
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            this.setLoading()

            this.repositories.assistenciaSocial.list()
                .then(({ data }) => {

                    data.model.periodo.start = this.getDateObject(data.model.periodo.start)
                    data.model.periodo.end = this.getDateObject(data.model.periodo.end)

                    this.initials.model = Object.freeze(this.clone(data.model))

                    this.form = data.form
                    this.model = data.model
                    this.additionals = data.additionals

                    this.loaded = true
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        }
    },
    mixins: [repository, error, object, data]
}
</script>